import React from "react";

import { useNavigate } from "react-router-dom";

import { LanguageSelector } from "components/LanguageSelector";

import { Container, LanguageSelectorWrapper } from "./styles";
import { LeftTemplate } from "../../../features/auth/LeftTemplate";
import { Form } from "../../../features/forms/Form";
import api from "../../../services/api";

export const ImportCertificate: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <LanguageSelectorWrapper>
        <LanguageSelector />
      </LanguageSelectorWrapper>
      <LeftTemplate backgroundImage="default" />
      <Form variant="certificate" navigate={navigate} api={api} />
    </Container>
  );
};
